export default "__VITE_ASSET__yN2M0$f7__"